import { NgModule } from '@angular/core';
import { CurrencyFormatDirective } from './currency-format.directive';
import { ImgFallbackDirective } from './img-fallback.directive';
import { UppercaseInputDirective } from './uppercase-input.directive';

/**
 * Módulo que expone la directiva CurrencyFormatDirective
 * para su uso en toda la aplicación.
 */
@NgModule({
    declarations: [CurrencyFormatDirective, ImgFallbackDirective, UppercaseInputDirective],
    exports: [CurrencyFormatDirective, ImgFallbackDirective, UppercaseInputDirective]
})
export class CurrencyDirectivesModule { }
